import type { RoomStatus } from '../../lib/rooms';

const STYLES: Record<RoomStatus, string> = {
  DRAFT: 'border-border-strong text-text-faint',
  LIVE: 'border-signal text-signal',
  FINISHED: 'border-accent-border text-accent',
  ARCHIVED: 'border-border-strong text-text-faint line-through',
};

/** DRAFT faint / LIVE coral tally / FINISHED lime / ARCHIVED struck — per DESIGN.md. */
export function StatusPill({ status }: { status: RoomStatus }) {
  return (
    <span className={`eyebrow inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 ${STYLES[status]}`}>
      {status === 'LIVE' && <span className="block size-1.5 rounded-full bg-signal blink" aria-hidden="true" />}
      {status}
    </span>
  );
}
